import { Injectable } from '@angular/core';
import { RouterStateSnapshot } from '@angular/router';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';

// Don't let the user access pages that they need to be logged in to see
@Injectable()
export class AuthGuard  {
  path: ActivatedRouteSnapshot[];
  route: ActivatedRouteSnapshot;

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isLoggedIn()) {
      return true;
    }

    // Store the attempted URL for redirecting
    this.authService.redirectUrl = state.url;
    // The user has no active WorkOS session to terminate here — just clear
    // any stale local state.
    this.authService.clearLocalSession();

    // Send them straight to WorkOS, so there is no "Log in" button to click first.
    // getAuthorizationUrl() persists redirectUrl to sessionStorage before redirecting, so the
    // post-callback navigation will deliver them to the page they wanted. When a login must
    // not start by itself, the login page waits for the click.
    if (this.authService.canStartLoginAutomatically()) {
      this.authService.startAutomaticLogin().subscribe(
        () => { /* AuthService has triggered window.location.href */ },
        () => this.router.navigate(['login'])
      );
    } else {
      this.router.navigate(['login']);
    }
    return false;
  }
}
